@if (unconfirmedTicket) {
  <div class="edit-container pb-3">
    <patron-form
      [formGroup]="formEditTicketOther"
      role="form"
      class="form-horizontal h-100"
      novalidate>
      <div class="row">
        <div class="col-2 py-0">
          <div class="form-group row">
            <div class="col py-0">
              <patron-select
                [formGroup]="formEditTicketOther"
                formControlName="type"
                [items]="ticketsTypes"
                placeholder="Tipo"
                bindLabel="label"
                label="Tipo">
              </patron-select>
            </div>
          </div>
        </div>
        <div class="col-5 py-0">
          <div class="form-group row justify-content-end">
            <div class="col py-0">
              <patron-select
                [formGroup]="formEditTicketOther"
                formControlName="ticketTypeCall"
                placeholder="Tipo chamada"
                bindLabel="description"
                orderBy="description"
                label="Tipo chamada"
                modelName="ticket-types">
              </patron-select>
            </div>
          </div>
        </div>
        <div class="col-5 py-0">
          <div class="form-group row align-items-center">
            <div class="col py-0">
              <patron-form-field
                type="date"
                formControlName="expectedDateStringTicket"
                [formGroup]="formEditTicketOther"
                placeholder="Previsão"
                label="Previsão">
              </patron-form-field>
            </div>
            <div class="col-auto py-0" style="margin-top: 1.75rem">
              <patron-button color="warning" size="sm" (click)="cleanExpectedDate.emit(null)">
                Limpar
              </patron-button>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 py-0">
          <patron-form-chips
            [formGroup]="formEditTicketOther"
            formControlName="tagsTicket"
            label="Tags">
          </patron-form-chips>
        </div>
      </div>
      <div class="row">
        <div class="col-6 py-0">
          <div class="form-group row">
            <div class="col-md py-0">
              <patron-form-field
                formControlName="estimatedEffort"
                [formGroup]="formEditTicketOther"
                placeholder="Esforço Técnico"
                label="Esforço Técnico"
                [isDisabled]="!dataService.shouldRecalculateTaskEffort">
              </patron-form-field>
            </div>
            <div class="col-md-auto py-0">
              <div class="row">
                <div class="col-auto pr-0 py-0"></div>
                <div class="col-auto mt-5 py-0">
                  <patron-form-check [inputTemplate]="input" [labelTemplate]="ignoreTask">
                    <ng-template #input>
                      <input
                        type="checkbox"
                        id="checkIgnore"
                        formControlName="ignoreTask"
                        (change)="updateIgnoreTasks()" />
                    </ng-template>
                    <ng-template #ignoreTask>
                      <label for="checkIgnore">Ignorar tarefas</label>
                    </ng-template>
                  </patron-form-check>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 py-0">
          <div class="form-group row justify-content-end font-weight-bold">
            <div class="col-md-11 py-0">
              <patron-form-field
                formControlName="commercialEstimatedEffort"
                [formGroup]="formEditTicketOther"
                placeholder="Esforço Comercial"
                label="Esforço Comercial">
              </patron-form-field>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-6 py-0">
          @if (
            unconfirmedTicket.user_opened &&
            (unconfirmedTicket.user_opened.name || unconfirmedTicket.user_opened.login)
          ) {
            <div class="form-group row">
              <div class="col-md-11 py-0">
                <patron-form-field
                  formControlName="userOpenedName"
                  [formGroup]="formEditTicketOther"
                  placeholder="Aberto por"
                  [isDisabled]="true"
                  label="Aberto por">
                </patron-form-field>
              </div>
            </div>
          }
        </div>
        <div class="col-6 py-0">
          <div class="form-group row justify-content-end">
            <div class="col-md-11 py-0">
              <patron-select
                [formGroup]="formEditTicketOther"
                formControlName="executor"
                placeholder="Executor"
                bindLabel="name"
                orderBy="name"
                label="Executor"
                modelName="users">
              </patron-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 py-0">
          <div class="form-group row">
            <div class="col-md-11 py-0">
              <patron-select
                [formGroup]="formEditTicketOther"
                formControlName="phaseTicket"
                placeholder="Fase"
                bindLabel="description"
                orderBy="description"
                label="Fase"
                modelName="phases">
              </patron-select>
            </div>
          </div>
        </div>
        <div class="col-6 py-0">
          <div class="form-group row justify-content-end">
            <div class="col-md-11 py-0">
              <patron-select
                [formGroup]="formEditTicketOther"
                formControlName="sprintTicket"
                placeholder="Sprint"
                bindLabel="description"
                orderBy="description"
                label="Sprint"
                modelName="sprints">
              </patron-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 py-0">
          <div class="form-group row">
            <div class="col-md-11 py-0">
              <patron-select
                [formGroup]="formEditTicketOther"
                formControlName="ticketProject"
                placeholder="Projeto"
                bindLabel="description"
                orderBy="description"
                label="Projeto"
                modelName="projects">
              </patron-select>
            </div>
          </div>
        </div>
        <div class="col-6 py-0">
          <div class="form-group row justify-content-end">
            <div class="col-md-11 py-0">
              <patron-select
                [formGroup]="formEditTicketOther"
                formControlName="ticketIssues"
                placeholder="Assunto"
                bindLabel="description"
                orderBy="description"
                label="Assunto"
                modelName="issues">
              </patron-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 py-0">
          <div class="form-group row">
            <div class="col-md-11 py-0">
              <patron-form-field
                formControlName="requesterTicket"
                [formGroup]="formEditTicketOther"
                placeholder="Solicitante"
                label="Solicitante">
              </patron-form-field>
              @if (wasValidated && !unconfirmedTicket.requester) {
                <div class="invalid-feedback custom-display-block">
                  Por favor informe o solicitante
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col-6 py-0">
          <div class="form-group row justify-content-end">
            <div class="col-md-11 py-0">
              <patron-form-field
                formControlName="phoneTicket"
                [formGroup]="formEditTicketOther"
                placeholder="Telefone"
                label="Telefone">
              </patron-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 py-0">
          <div class="form-group row">
            <div class="col-md-11 py-0">
              <patron-form-field
                type="date"
                formControlName="analysisExpectedDateTicket"
                [formGroup]="formEditTicketOther"
                placeholder="Previsão análise"
                label="Previsão análise">
              </patron-form-field>
            </div>
          </div>
        </div>
        <div class="col-6 py-0">
          <div class="form-group row justify-content-end">
            <div class="col-md-11 py-0">
              <patron-form-field
                type="date"
                formControlName="developmentExpectedDateTicket"
                [formGroup]="formEditTicketOther"
                placeholder="Previsão desenv."
                label="Previsão desenv.">
              </patron-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 py-0">
          <patron-select
            [formGroup]="formEditTicketOther"
            formControlName="usersPartTicket"
            placeholder="Participantes"
            bindLabel="name"
            orderBy="name"
            label="Participantes"
            modelName="users"
            [multiple]="true">
          </patron-select>
        </div>
      </div>
      <div class="row">
        <div class="col-6 py-0">
          <div class="form-group row">
            <div class="col-md-11 py-0">
              <patron-form-field
                type="text"
                formControlName="emailTicket"
                [formGroup]="formEditTicketOther"
                placeholder="Email"
                label="Email">
              </patron-form-field>
            </div>
          </div>
        </div>
        <div class="col-6 py-0">
          <div class="form-group row justify-content-end">
            <div class="col-md-11 py-0">
              <patron-select
                [formGroup]="formEditTicketOther"
                formControlName="releaseSituation"
                [items]="ticketsReleaseSituations"
                placeholder="Situação da Release"
                bindLabel="label"
                label="Situação da Release">
              </patron-select>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header cursor-pointer font-weight-bold" (click)="toggleSolution()">
          Solução
          <i
            class="text-muted fa fa-lg {{
              showSolution ? 'fa-caret-down' : 'fa-caret-right'
            }} float-right pr-1 pt-1"></i>
        </div>
        @if (showSolution) {
          <div class="card-body">
            <span style="white-space: pre-line">{{ unconfirmedTicket.solution }}</span>
          </div>
        }
      </div>
      <div class="card mt-3">
        <div class="card-header cursor-pointer font-weight-bold" (click)="toggleObservation()">
          Observação
          <i
            class="text-muted fa fa-lg {{
              showObservation ? 'fa-caret-down' : 'fa-caret-right'
            }} float-right pr-1 pt-1"></i>
        </div>
        @if (showObservation) {
          <div class="card-body">
            <span style="white-space: pre-line">{{ unconfirmedTicket.observation }}</span>
          </div>
        }
      </div>
    </patron-form>
    <!-- <form #form="ngForm" role="form" class="form-horizontal {{ wasValidated ? 'was-validated' : ''}} h-100" novalidate> -->
    <!-- </form> -->
  </div>
}
